export default {"src":"/_next/static/media/VolDeMouettesFormations.61289fc0.svg","height":435,"width":1031};